import ProdutoServicoService from "../../services/ProdutoServicoService";
import SelectProdutoServico from "./SelectProdutoServico";

export default class SelectProdutoServicoByTipoUsuarioOrdemTipo extends SelectProdutoServico {

    componentDidUpdate(nextProps) {
        super.componentDidUpdate(nextProps);
        if (nextProps.idTipoProdutoServico !== this.props.idTipoProdutoServico) {
            this.getOptions();
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        if (this.props.idTipoProdutoServico) {
            ProdutoServicoService.getForComboByTipoUsuarioOrdemTipo(this.props.idTipoProdutoServico, this.props.idOrdemTipo, (response) => {
                this.setState({ options: response }, () => {
                    if (callBack) {
                        callBack();
                        if (this.props.openSearchOnUpdate) {
                            this.handleOpenSearch();
                        }
                    }
                });
            });
        } else {
            this.setState({ options: [] }, () => {
                if (callBack) {
                    callBack();
                }
            });
        }
    }

    render() {
        return super.render();
    }
}